import { createFileRoute } from "@tanstack/react-router";
import {
  portfolioReviewQueryOptions,
  usePortfolioReview,
} from "creso-core/hooks";
import { ReviewWorkbench } from "@/modules/portfolio-review/components/workbench/review-workbench";

// Not nested under the client layout: the workbench is a full-width page.
export const Route = createFileRoute(
  "/(auth)/_headed/clients/$id_/review/$reviewId"
)({
  component: RouteComponent,
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      portfolioReviewQueryOptions(Number(params.reviewId))
    ),
});

function RouteComponent() {
  const { reviewId } = Route.useParams();
  // Line edits patch this cache entry, so read it live, not from the loader.
  const { data: review } = usePortfolioReview(Number(reviewId));
  return review ? <ReviewWorkbench review={review} /> : null;
}
